<template>
  <div class="home">
<!--    <test></test>-->
<!--    <main-page></main-page>-->
    <scroll-page></scroll-page>
  </div>
</template>

<script>

// import Test from "../components/Test.vue";
// import MainPage from "./mainPage.vue";
import ScrollPage from "./scrollPage.vue";
import { parseGIF, decompressFrames } from 'gifuct-js'
export default {
  name: 'Home',
  components: {
    ScrollPage,
    // MainPage,
    // Test
  },
  data() {
    return {}
  },
  mounted() {
    // this.disposeGif('https://hbrbapp.hubeidaily.net/h5/family-photo/fu-gif.gif')
  },
  methods: {
    // disposeGif (gifURL) {
    //   const promisedGif = fetch(gifURL)
    //       .then(resp => resp.arrayBuffer())
    //       .then(buff => {
    //         const gif = parseGIF(buff)
    //         const frames = decompressFrames(gif, true)
    //         // console.log(frames[0])
    //         const frame = frames[0]
    //         console.log(new Uint8ClampedArray(frame.pixels))
    //         const imageData = new ImageData(new Uint8ClampedArray(frame.pixels), frame.width, frame.height)
    //         console.log(imageData)
    //         return gif
    //       });
    // }
  }
}
</script>

<style scoped lang="scss">
@import './index.scss';
.home {
  width: 100vw;
  height: 100vh;
  background: #c8f2ff;
}
</style>
